var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.667 31.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.01 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.01 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.433.142A.625.625,0,0,0,30.75.086L.338,16.559a.627.627,0,0,0,.1,1.148l8.645,2.821L8.25,29.088a.627.627,0,0,0,1.094.477l5.451-6.16L23.006,31.5a.625.625,0,0,0,.44.181.646.646,0,0,0,.17-.023.625.625,0,0,0,.438-.452L31.658.79A.625.625,0,0,0,31.433.142ZM10.36,20.411l12.361-9.995L14.3,22.08l-4.61,5.2Z",
    transform: "translate(-0.01 -0.01)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteuser);
export default __webpack_public_path__ + "static/media/inviteuser.28ebfa885dd4ae499ab6ed33feee1bde.svg";
export { ForwardRef as ReactComponent };